import React from 'react';
import PropTypes from 'prop-types';
import ListTag from '../components/ListTag';
import ListData from '../components/ListData';
import Item from '../components/Item';
import Axios from 'axios';
import { API_HOST } from '../consts';
import { get } from 'lodash';

export default class ListItem extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    photo: PropTypes.string,
    description: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    children: PropTypes.element,
    status: PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string
    }).isRequired,
    onClickExpand: PropTypes.func,
    onClickGroup: PropTypes.func,
    groupIcon: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.element),
    startCollapsed: PropTypes.bool,
    handleChecked: PropTypes.func,
    checked: PropTypes.object
  };

  static defaultProps = {
    title: '',
    photo: '',
    description: [],
    children: null,
    onClickExpand: () => {},
    onClickGroup: () => {},
    groupIcon: false,
    actions: [],
    startCollapsed: false,
    handleChecked: () => {},
    checked: {}
  };

  componentDidMount() {
    this.fetchItens();
  }

  constructor(props) {
    super(props);
    this.onClickExpand = this.onClickExpand.bind(this);
    this.onClickGroup = this.onClickGroup.bind(this);
    this.state = {
      collapse: props.startCollapsed,
      collapseGroup: false
    };
  }

  onClickExpand() {
    this.setState(
      { collapse: !this.state.collapse, collapseGroup: false },
      () => setTimeout(this.props.onClickExpand, 500)
    );
  }

  onClickGroup() {
    this.setState({
      collapseGroup: !this.state.collapseGroup,
      collapse: false
    });
  }

  fetchItens = () => {
    const { recurso } = this.props;
    try {
      Axios.get(`${API_HOST}/itens/item/${recurso.item}`).then((response) => {
        const itens = response.data;
        this.setState({ itens });
      });
    } catch (e) {
      console.error(e);
    }
  };

  renderImage() {
    if (this.props.photo) {
      return (
        <img
          className="image"
          alt={this.props.title}
          src={this.props.photo}
          width="100"
          height="100"
        />
      );
    }

    return null;
  }

  render() {
    const { itens } = this.state;
    const {
      description,
      title,
      small,
      status,
      vertical,
      actions,
      details,
      atualizado_em,
      versao,
      buttons,
      criado_em,
      showContent,
      show_id,
      recurso,
      handleChecked,
      checked
    } = this.props;

    return (
      <div className="list-item-base">
        <div className="container">
          <div className="row">
            <div className="checkbox-input-item col-lg-1 col-md-1 col-sm-2 col-xs-2">
              {this.renderImage()}
              <label className="container-check-custom">
                <input
                  type="checkbox"
                  aria-label=""
                  id={`checkbox-${get(recurso, 'id')}`}
                  onChange={(e) => handleChecked(e, get(recurso, 'id'))}
                  checked={checked[get(recurso, 'id')]}
                />
                <span className="checkmark" />
              </label>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-10 col-xs-10">
              <ListData
                vertical={vertical}
                description={description}
                title={title}
                small={small}
                atualizado_em={atualizado_em}
                criado_em={criado_em}
                versao={versao}
                buttons={buttons}
              />
            </div>
            <div
              style={{ paddingLeft: 50, marginLeft: 40 }}
              className="col-lg-3 col-md-3 col-xs-12 col-sm-12"
            >
              <ListTag
                onClickExpand={this.onClickExpand}
                details={details}
                actions={actions}
                groupIcon={this.props.groupIcon}
                onClickGroup={this.onClickGroup}
                {...status}
              />
            </div>
            {show_id == get(recurso, 'id') && recurso ? (
              <div
                className="container"
                key={show_id}
                id={show_id}
                style={{ padding: '40px' }}
              >
                <Item item={itens} />
                <hr />
                <label>Justificativa</label>
                <p
                  dangerouslySetInnerHTML={{ __html: recurso.justificativa }}
                ></p>

                <label>Julgamento</label>
                <p dangerouslySetInnerHTML={{ __html: recurso.julgamento }}></p>
                <label>Medida</label>
                <p dangerouslySetInnerHTML={{ __html: recurso.medida }}></p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
